<template>
    <v-dialog v-model="open" max-width="900px" persistent>
        <v-card>
            <v-toolbar flat>
                <v-toolbar-title>Duplicar {{ titleByStatus(mapped.status) }}</v-toolbar-title>
                <v-spacer/>
                <v-btn icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-divider/>
            <!-- Reusamos tu Create.vue y le inyectamos 'initialQuotation' + 'mode' -->
            <Create
                v-if="open"
                :message="messageFromContext"
                :initialQuotation="mapped"
                mode="duplicate"
                @closeCreateDialogQuotation="onSaved"
            />
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios'
import Create from './create'

export default {
    name: 'DuplicateSale',
    components: { Create },
    props: {
        value: { type: Boolean, default: false }, // v-model para abrir el modal
        saleId: { type: [Number, String], required: true },
        // Si ya tienes el objeto completo y quieres ahorrarte el GET, puedes pasarlo:
        sourceSale: { type: Object, default: null },
    },
    data: () => ({
        open: false,
        raw: null,
        mapped: null,
    }),
    computed: {
        messageFromContext() {
            // Tu Create.vue espera message = [companyId, status]
            if (!this.mapped) return [null, 'quotation']
            return [this.mapped.company_id || null, this.mapped.status || 'quotation']
        },
    },
    watch: {
        value: {
            immediate: true,
            handler (v) {
                this.open = v
                if (v) this.bootstrap()
            }
        }
    },
    methods: {
        titleByStatus(s) {
            if (s === 'vendido' || s === 'pedido') return 'Venta'
            if (s === 'quotation') return 'Cotización'
            return 'Venta'
        },
        close() {
            this.$emit('input', false)
        },
        onSaved(payload) {
            // se dispara cuando Create.vue cierra después de crear
            this.$emit('input', false)
            this.$emit('duplicated', payload)
        },
        async bootstrap() {
            try {
                const base = this.sourceSale || (await this.fetchSale(this.saleId))
                this.raw = base
                this.mapped = this.normalizeForDuplicate(base)
            } catch (e) {
                console.error(e)
                this.$emit('input', false)
            }
        },
        fetchSale(id) {
            const url = process.env.VUE_APP_BACKEND_ROUTE + `api/v2/sales?filter[id]=${id}`
            return axios.get(url).then(r => r.data.data[0])
        },
        normalizeForDuplicate(src) {
            const isMF = process.env.VUE_APP_BACKEND_ROUTE === 'https://backendmf.unocrm.mx/';
            const company_id = src.company?.id || src.company_id || null;
            const company_branch_id = src.company_branch?.id || src.company_branch_id || '';
            const contact_id = src.contact?.id || src.contact_id || '';

            // 1) Items para el formulario de creación
            const items = (src.items || []).map(d => ({
                quantity: Number(d.quantity) || 1,
                item: (d.item && d.item.id) ? d.item.id : (d.item || ''),
                price: Number(d.price || 0),
                discount: Number(d.discount || 0),
                manual_price: true, // respeta el precio copiado
            }));

            // 2) Catálogo de productos para que productsList tenga datos
            //    (tomamos el objeto d.item de cada renglón)
            const uniqueById = {};
            const productsFromItems = (src.items || [])
                .map(d => d.item)
                .filter(Boolean)
                .map(p => ({
                    // Campos mínimos que usa tu UI
                    id: p.id,
                    name: p.name,
                    code_one: p.code_one,
                    price: Number(p.price || 0),        // fallback si lo ocupas en UI
                    cost: Number(p.cost || 0),
                    categories: p.categories || [],
                    branch_inventories: p.branch_inventories || {}, // evita undefined
                }))
                .filter(p => {
                    if (!p || !p.id) return false;
                    if (uniqueById[p.id]) return false;
                    uniqueById[p.id] = true;
                    return true;
                });

            // 3) Tipo y fechas
            const duplicated = {
                global_discount: Number(src.global_discount || 0),
                company_id,
                contact_id: contact_id || '',
                user_id: src.user_id?.id || src.user_id || null,
                pdf: '',
                note: src.note || '',
                internal_note: src.internal_note || '',
                items: items.length ? items : [{ quantity: 1, item: '', price: '', discount: 0 }],
                bar: src.bar ? 1 : 0,
                status: src.status || 'quotation',
                subtotal: '', // se recalcula con watcher
                date: src.date || '',            // ← prellenado
                due_date: src.due_date || '',    // ← prellenado (para cotización)
                type: src.type == 'CEDIS' ? 'Serie A' : src.type, // ← igual que Create
                iva: '',
                total: '',
                invoice: '',
                printed: '',
                created_by_user_id: '',
                last_updated_by_user_id: '',
                invoice_date: '',
                company_branch_id: company_branch_id || '',
                purchase_order: src.purchase_order || '',
            };

            duplicated._entries = {
                companies: src.companies || (src.company ? [src.company] : []),
                company_branches: src.company_branches || (src.company_branch ? [src.company_branch] : []),
                contacts: src.contacts || (src.contact ? [src.contact] : []),
                products: productsFromItems, // ← clave para productsList
            };

            return duplicated;
            }

    }
}
</script>